import axios from 'axios';
import { toast } from 'react-toastify';

const BASE_URL = 'https://api.hvacsync.in';

// Helper function to handle logout and cleanup
const handleLogout = () => {
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.removeItem("admin"); // Clear any other auth-related data
    
    // Redirect to login page
    window.location.href = '/Signin'; 
};

const axiosInstance = axios.create({
    baseURL: BASE_URL, 
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// --- REFRESH TOKEN LOGIC (Interceptor) ---

// 1. Request Interceptor
axiosInstance.interceptors.request.use(config => {
    const access = localStorage.getItem('access');
    if (access) {
        config.headers.Authorization = `Bearer ${access}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

// 2. Response Interceptor
axiosInstance.interceptors.response.use(
    (response) => response, 
    async (error) => {
        const originalRequest = error.config;
        
        // Handle 401 Unauthorized (Token Expired)
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true; 

            const refresh = localStorage.getItem('refresh');
            
            if (!refresh) {
                toast.error("Session expired. Please login again.");
                handleLogout();
                return Promise.reject(error);
            }
            
            try {
                // Call the refresh endpoint
                const refreshResponse = await axios.post(`${BASE_URL}/auth/token/refresh/`, {
                    refresh: refresh
                });
                
                // Extract new access token (Note: access is inside .data)
                const newAccess = refreshResponse.data.access; 
                
                localStorage.setItem("access", newAccess);

                // Update the Authorization header and retry original request
                originalRequest.headers.Authorization = `Bearer ${newAccess}`;
                return axiosInstance(originalRequest);

            } catch (refreshError) {
                toast.error("Your session has expired. Please login again.");
                handleLogout();
                return Promise.reject(refreshError);
            }
        }
        
        // Handle 400 Bad Request (Validation Errors)
        if (error.response?.status === 400) {
            // Extract the error message from the backend if available
            const serverMessage = error.response.data?.message || 
                                 JSON.stringify(error.response.data);
            toast.error(`Request Error: ${serverMessage}`);
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;